
import { requestState } from 'utils/UtilityStore/actions';

export const loading = () => (dispatch) => {
  dispatch(requestState(true, 'processDetails'));
};

export const unloading = () => (dispatch) => {
  dispatch(requestState(false, 'processDetails'));
};